import { useEffect, useState } from "react";

export const HideSSR: React.FC<{
  children: React.ReactNode | React.ReactNode[];
}> = ({ children }) => {
  const [render, setRender] = useState(false);
  useEffect(() => {
    setRender(typeof document !== "undefined" && typeof window !== "undefined");
  }, []);
  if (!render) return null;
  return <>{children}</>;
};
